export default __webpack_public_path__ + "6af4980d24f2778d94e550a732fdcd8a.png";